import { formatINR, formatINRCompact } from "@garage/shared";

export { formatINR, formatINRCompact };

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function formatKm(km: number | null): string {
  return km == null ? "—" : `${km.toLocaleString("en-IN")} km`;
}

export type ExpiryStatus = "expired" | "soon" | "ok" | "unknown";

/** Days until an expiry date, counted in whole days from today. */
export function daysUntil(iso: string | null): number | null {
  if (!iso) return null;
  const today = new Date();
  const start = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  return Math.round((Date.parse(`${iso}T00:00:00Z`) - start) / 86_400_000);
}

export function expiryStatus(iso: string | null): ExpiryStatus {
  const d = daysUntil(iso);
  if (d === null) return "unknown";
  if (d < 0) return "expired";
  return d <= 30 ? "soon" : "ok";
}

export function expiryLabel(iso: string | null): string {
  const d = daysUntil(iso);
  if (d === null) return "not set";
  if (d < 0) return `expired ${Math.abs(d)}d ago`;
  if (d === 0) return "expires today";
  return `${d}d left`;
}
